import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { desenlazarApp } from "../services/app.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useDesenlazarApp = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const desenlazarAppMutation = useMutation({
        mutationFn: desenlazarApp,
        onSuccess: (cita, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ['resumenPaciente', id] });
            dispatch(successNotification('App desenlazada'));
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        desenlazarAppMutation,
    }
}